var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralPrinciples(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{clip-path:url(#SVGID_00000176003501135403648930000011701936678125050266_);}\n\t.st3{fill:#E86E7B;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173878369962847029530000009401534818410912664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173878369962847029530000009401534818410912664_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9,23.7h-6.4v-6.6c0-1.5-1.1-2.8-2.6-3c-0.3,0-6.5-1-14,0.4c-8.4,1.5-15,5.3-19.6,10.9c-4.5-5.7-11.2-9.4-19.6-10.9 c-7.5-1.4-13.7-0.5-14-0.4c-1.5,0.2-2.6,1.5-2.6,3v6.6H9.8c-1.7,0-3.1,1.4-3.1,3v57.7c0,1,0.5,1.9,1.3,2.5c0.8,0.6,1.8,0.7,2.8,0.4 c0.2-0.1,23.2-7.9,40.3-0.1c0.8,0.4,1.7,0.4,2.5,0c17.1-7.8,40.1,0,40.3,0.1c0.3,0.1,0.7,0.2,1,0.2c0.6,0,1.2-0.2,1.8-0.6 c0.8-0.6,1.3-1.5,1.3-2.5V26.8C98,25.1,96.6,23.7,94.9,23.7z M12.9,80.4V29.9h3.3v40.8c0,0.9,0.4,1.7,1.1,2.3 c0.7,0.6,1.6,0.9,2.4,0.7c0.2,0,13.5-1.9,23.2,4.8C30.9,76.4,19,78.8,12.9,80.4z M49.3,75.7c-4.3-3.8-9.9-6.5-16.5-7.7 c-3.2-0.6-6.2-0.8-8.5-0.8c-0.7,0-1.4,0-1.9,0V19.9l0,0c5.9-0.3,20.2,0.3,27,11.9V75.7z M55.4,31.8c6.8-11.4,21.1-12.1,27-11.9v47.4 c-2.6-0.1-6.3,0-10.5,0.7c-6.6,1.2-12.2,3.8-16.5,7.7V31.8z M61.8,78.5c9.7-6.7,23-4.9,23.2-4.8c0.9,0.2,1.8-0.1,2.4-0.7 c0.7-0.6,1.1-1.4,1.1-2.4V29.9h3.3v50.5C85.8,78.8,73.8,76.4,61.8,78.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralPrinciples);
export default __webpack_public_path__ + "static/media/generalPrinciples.8c686749cedcc4b46169b6c243cedeac.svg";
export { ForwardRef as ReactComponent };